import { render, staticRenderFns } from "./DinamicClass.vue?vue&type=template&id=560d1630&scoped=true"
import script from "./DinamicClass.vue?vue&type=script&lang=js"
export * from "./DinamicClass.vue?vue&type=script&lang=js"
import style0 from "./DinamicClass.vue?vue&type=style&index=0&id=560d1630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d1630",
  null
  
)

export default component.exports